<script>
    import sysData from "../../Stores/systemStore.js";
    import ItemNameCell from "../Browsing/ItemNameCell.svelte";
    import ItemDateCell from "../Browsing/ItemDateCell.svelte";
    import ItemStatusCell from "../Browsing/ItemStatusCell.svelte";
    import ItemStatusIconCell from "../Browsing/ItemStatusIconCell.svelte"
    import ItemTypeCell from "../Browsing/ItemTypeCell.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { firstAssociatedItemForEntities } from "../../scripts/wpn2Model.js";

    export let item;
    let infraColor = $sysData.colors[item.infrastructure ?? 'Unknown'] ?? $sysData.colors['Unknown'];

    // function sensorNameForItem() {
    //     const sensor = firstAssociatedItemForEntities(['Sensor'], $dbData.alfx_data, item, true, false, false, false);
    //     return sensor?.name ?? "Unknown";
    // }
</script>

<div class="summary-container">
    <div class="summary-info" style="border-left: {'8px solid ' + infraColor}">
        <div id="two-col-part">
            <div id="summary-name-type">
                <ItemNameCell {item} />
                <div id="item-type-col">
                    <ItemTypeCell {item} />
                </div>
            </div>
            <div id="summary-status-date">
                <div id="item-status-col">
                    {#if ['SoundLocation', 'Sensor'].includes(item.entity)}
                        <ItemStatusIconCell {item} showTitle={true} />
                    {:else}
                        <ItemStatusCell {item} showTitle={true} />
                    {/if}
                </div>
                <div id="item-date-col">
                    <ItemDateCell {item} showTitle={true} />
                </div>
            </div>    
        </div>
        {#if item.entity == 'Sensor'}
            <p id="sensor-id">{"ID: " + item?.device_sn ?? "Unknown"}</p>
        {/if}
        {#if ['SoundLocation', 'Sensor'].includes(item.entity)}
            <p id="summary-statement">{"Summary: " + item?.summary ?? "Unavailable"}</p>
        {/if}
    </div>
</div>

<style>
    .summary-container {
        padding: 8px 0 16px 0;
        border-bottom: 0.25px solid lightgray;
    }
    .summary-info {
        position: relative;
        padding: 0 8px;
    }
    #two-col-part {
        display: flex;
    }
    #summary-name-type {
        flex: 1;
        padding: 4px 0;
    }
    #summary-status-date  {
        flex: 1;
        margin: auto;
        padding: 4px 0;
    }
    #item-type-col {
        margin-left: 12px;
    }
    #item-date-col, #item-status-col {
        margin-top: 10px;
    }
    #sensor-id, #summary-statement {
        margin: 10px 0 0 12px;
    }
</style>
